import { render } from "./AssetsPage.vue?vue&type=template&id=8c0fea4a&scoped=true"
import script from "./AssetsPage.vue?vue&type=script&lang=js"
export * from "./AssetsPage.vue?vue&type=script&lang=js"

import "./AssetsPage.vue?vue&type=style&index=0&id=8c0fea4a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c0fea4a"]])

export default __exports__